import { 
  AdminPanelSettings as AdminIcon,
  Person as UserIcon,
  Visibility as ViewIcon,
  Business as BusinessIcon,
  Schedule as PendingIcon,
  CheckCircle as AcceptedIcon,
  Cancel as DeclinedIcon,
  AccessTime as ExpiredIcon
} from '@mui/icons-material';

// Organization type mapper
export const getOrgTypeLabel = (type: string): string => {
  const labels: Record<string, string> = {
    law_firm: 'Law Firm',
    record_label: 'Record Label',
    management_company: 'Management Company',
    publishing_company: 'Publishing Company',
    production_company: 'Production Company',
    talent_agency: 'Talent Agency',
    distribution_company: 'Distribution Company',
    other: 'Other'
  };
  return labels[type] || 'Organization';
};

// Role label mapper
export const getRoleLabel = (role: string, customRoleName?: string): string => {
  if (role === 'custom' && customRoleName) {
    return customRoleName;
  }
  
  const labels: Record<string, string> = {
    primary_owner: 'Primary Owner',
    admin: 'Admin',
    billing_admin: 'Billing Admin',
    member: 'Member',
    viewer: 'Viewer',
    custom: 'Custom Role'
  };
  return labels[role] || role;
};

// Role icon mapper - returns unstyled icon components for consistent styling
export const getRoleIcon = (role: string) => {
  switch (role) {
    case 'primary_owner':
    case 'admin':
      return AdminIcon;
    case 'billing_admin':
      return BusinessIcon;
    case 'viewer':
      return ViewIcon;
    default:
      return UserIcon;
  }
};

// Legacy role icon with styling (for backward compatibility)
export const getRoleIconStyled = (role: string) => {
  switch (role) {
    case 'primary_owner':
    case 'admin':
      return <AdminIcon className="w-4 h-4 text-yellow-500" />;
    case 'billing_admin':
      return <BusinessIcon className="w-4 h-4 text-green-500" />;
    case 'viewer':
      return <ViewIcon className="w-4 h-4 text-gray-500" />;
    default:
      return <UserIcon className="w-4 h-4 text-purple-500" />;
  }
};

// Invitation status icon mapper - returns unstyled icon components for consistent styling
export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'pending':
      return PendingIcon;
    case 'accepted':
      return AcceptedIcon;
    case 'declined':
      return DeclinedIcon;
    case 'expired':
      return ExpiredIcon;
    default:
      return PendingIcon;
  }
};

// Legacy status icon with styling (for backward compatibility)
export const getStatusIconStyled = (status: string) => {
  switch (status) {
    case 'pending':
      return <PendingIcon className="w-4 h-4 text-yellow-500" />;
    case 'accepted':
      return <AcceptedIcon className="w-4 h-4 text-green-500" />;
    case 'declined':
      return <DeclinedIcon className="w-4 h-4 text-red-500" />;
    case 'expired':
      return <ExpiredIcon className="w-4 h-4 text-gray-500" />;
    default:
      return <PendingIcon className="w-4 h-4 text-gray-500" />;
  }
};

// Date formatter
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Icon utility - creates a styled icon component from an icon component type
export const createStyledIcon = (IconComponent: any, className?: string) => {
  return <IconComponent className={className} />;
};